<template>
    <ul class="aside-navigation">
      <li><strong>Ferestre de mansarda:</strong></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.dubla_articulare.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.dubla_articulare.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.dubla_articulare.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.articulare_mediana.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.articulare_mediana.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.articulare_mediana.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.rezistenta_umezeala.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.rezistenta_umezeala.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.rezistenta_umezeala.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.actionare_electrica.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.actionare_electrica.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.actionare_electrica.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.case_pasive.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.case_pasive.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.case_pasive.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.antiefractie_secure.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.antiefractie_secure.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.antiefractie_secure.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.ferestre_arc.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.ferestre_arc.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.ferestre_arc.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.superinalte.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.superinalte.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.superinalte.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.panoramice.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.panoramice.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.panoramice.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.balcon.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.balcon.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.balcon.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.atic.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.atic.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.atic.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.evacuarea_fumului.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.evacuarea_fumului.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.evacuarea_fumului.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.acces_acoperis.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.acces_acoperis.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.acces_acoperis.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.top.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.top.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.top.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.non_standard.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.non_standard.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.non_standard.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.fara_deschidere.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.fara_deschidere.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.fara_deschidere.profil }}</a></li>
      <li><font-awesome-icon icon="folder" class="fas"></font-awesome-icon><a :href="'/fakro/'+this.$parent.products.cu_deschidere.nume.toLowerCase().split(' ').join('-')" class="aside-navigation__link" :class="{active: $route.params.product == this.$parent.products.cu_deschidere.nume.toLowerCase().split(' ').join('-')}">{{ this.$parent.products.cu_deschidere.profil }}</a></li>
    </ul>
</template>
<script>
export default {
  data() {
    return {
      name: "fakroAside"
    };
  }
  // Varianta secundara folosind fetch API
  // created: function() {
  //   fetch("http://acoperis-expert.ro/data/ruuki-categories.json")
  //     .then(r => r.json())
  //     .then(json => {
  //       this.categories = json;
  //     });
  // }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";
#aside {
  background-color: $white;
  box-shadow: 0 10px 20px 2px rgba(0, 0, 0, 0.05);
  .aside-header {
    border-bottom: 2px solid $dark-gray;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 1rem;
    a {
      border-right: 2px solid $dark-gray;
      color: $text-color;
      margin-right: 1rem;
      padding: 1rem;
      &:hover {
        box-shadow: 0 0 20px -2px rgba(0, 0, 0, 0.15);
        color: $primary-color;
      }
    }
    h3 {
      font-size: 1.5rem;
      margin: 0;
      width: 100%;
    }
    img {
      height: auto;
      width: 60px;
    }
  }
  .aside-navigation {
    li {
      display: flex;
      align-items: center;
      padding: 0 1rem;
      &:last-child {
        .aside-navigation__link {
          border: 0;
        }
      }
      .fas {
        font-size: 1rem;
        margin-right: 1rem;
      }
    }
    &__link {
      border-bottom: 1px solid $dark-gray;
      color: $text-color;
      display: block;
      font-size: 1rem;
      padding: 10px 0;
      width: 100%;
      &:hover {
        color: $primary-color;
      }
    }
    .active {
      color: $primary-color;
    }
  }
}

/*=============================================
=            RESPONSIVE            =
=============================================*/
@media (max-width: 991.98px) {
  #aside {
    background: none;
    box-shadow: none;
    .aside-header {
      background: $white;
      box-shadow: 0 10px 20px 2px rgba(0, 0, 0, 0.05);
      border: 0;
      margin-bottom: 1rem;
    }
    .aside-navigation {
      display: flex;
      flex-wrap: wrap;
      li {
        background-color: $white;
        border: 1px solid darken($light-gray, 1%);
        margin: 0 0.5rem 0.5rem 0;
      }
      &__link {
        border: 0;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/fakroAside.vue